import { SvgIcon } from "@mui/material";
import Logo from "./Logo";

const HeaderLogo = ({minWidth,alignItems="center", maxHeight="48px"}) => {
  return (
    <div style={{ flexGrow: 1, display: "flex" , alignItems}}>
        <SvgIcon component={Logo}  {...{maxHeight, minWidth}}/>
    </div>
  );
};

export default HeaderLogo;